// Keep lifecycle choices aligned with cinema-admin-service/src/lib/seriesStatus.js.
export const SERIES_STATUS_COLORS = {
  DRAFT: 'brown',
  IN_REVIEW: 'yellow',
  APPROVED: 'blue',
  SCHEDULED: 'blue',
  ACTIVE: 'green',
  INACTIVE: 'grey',
  REJECTED: 'red',
  SUSPENDED: 'red',
  EXPIRED: 'red',
  ARCHIVED: 'red',
  DELETED: 'red',
};

const TRANSITIONS = {
  DRAFT: ['IN_REVIEW'],
  IN_REVIEW: ['APPROVED', 'REJECTED'],
  REJECTED: ['IN_REVIEW'],
  APPROVED: ['SCHEDULED', 'ACTIVE'],
  SCHEDULED: ['ACTIVE'],
  ACTIVE: ['INACTIVE'],
  INACTIVE: ['IN_REVIEW'],
};

export const getSeriesStatusOptions = (status, isNew = false) => {
  if (isNew) return ['DRAFT'];
  if (!Object.prototype.hasOwnProperty.call(SERIES_STATUS_COLORS, status)) return [];
  return [status, ...(TRANSITIONS[status] || [])];
};

export const getSeriesStatusColor = (status) => SERIES_STATUS_COLORS[status] || 'grey';
